import Vue from 'vue'
import Router from 'vue-router'

import DashboardLayout from '@/components/layout/DashboardLayout.vue'
import EmbedLayout from '@/components/layout/EmbedLayout.vue'
import DashboardGeral from '@/views/DashboardGeral.vue'
import SectorDashboard from '@/views/SectorDashboard.vue'
import UnauthorizedView from '@/views/Unauthorized.vue'

import { getAuthToken, getUserPermissions, setAuthToken } from '@/services/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/unauthorized', name: 'unauthorized', component: UnauthorizedView },
    { path: '/', redirect: '/geral-comercial' },
    {
      path: '/',
      component: DashboardLayout,
      children: [
        { path: 'geral', component: DashboardGeral },
        { path: 'geral-comercial', component: DashboardGeral },
        {
          path: 'comercial',
          component: SectorDashboard,
          props: { sector: 'comercial', title: 'Comercial', subtitle: 'Gestão de vendas, faturamento e conversões' },
        },
        {
          path: 'marketing',
          component: SectorDashboard,
          props: { sector: 'marketing', title: 'Marketing', subtitle: 'Gestão de investimentos, leads e custos de aquisição' },
        },
        {
          path: 'operacoes',
          component: SectorDashboard,
          props: { sector: 'operacoes', title: 'Operações', subtitle: 'Gestão de prazos de envio e logística operacional' },
        },
        {
          path: 'compras',
          component: SectorDashboard,
          props: { sector: 'compras', title: 'Compras', subtitle: 'Gestão de economias, aquisições e prazos' },
        },
        {
          path: 'sucesso',
          component: SectorDashboard,
          props: { sector: 'sucesso', title: 'Sucesso do Cliente', subtitle: 'Gestão de NPS e tempo de atendimento' },
        },
        {
          path: 'ti',
          component: SectorDashboard,
          props: { sector: 'ti', title: 'TI', subtitle: 'Gestão de prejuízo evitado, despesas e receita por IA' },
        },
        {
          path: 'logistica',
          component: SectorDashboard,
          props: { sector: 'logistica', title: 'Logística', subtitle: 'Gestão de savings e turmas atendidas' },
        },
        {
          path: 'academico',
          component: SectorDashboard,
          props: { sector: 'academico', title: 'Acadêmico', subtitle: 'Gestão de inscrições, conversão e prazos' },
        },
      ],
    },

    // Rotas para embed (iframe) - sem menu lateral
    {
      path: '/embed',
      component: EmbedLayout,
      meta: { embed: true },
      children: [
        { path: '', redirect: 'geral' },
        { path: 'geral', component: DashboardGeral, meta: { embed: true } },
        {
          path: 'comercial',
          component: SectorDashboard,
          props: { sector: 'comercial', title: 'Comercial', subtitle: 'Gestão de vendas, faturamento e conversões' },
          meta: { embed: true },
        },
        {
          path: 'marketing',
          component: SectorDashboard,
          props: { sector: 'marketing', title: 'Marketing', subtitle: 'Gestão de investimentos, leads e custos de aquisição' },
          meta: { embed: true },
        },
        {
          path: 'operacoes',
          component: SectorDashboard,
          props: { sector: 'operacoes', title: 'Operações', subtitle: 'Gestão de prazos de envio e logística operacional' },
          meta: { embed: true },
        },
        {
          path: 'compras',
          component: SectorDashboard,
          props: { sector: 'compras', title: 'Compras', subtitle: 'Gestão de economias, aquisições e prazos' },
          meta: { embed: true },
        },
        {
          path: 'sucesso',
          component: SectorDashboard,
          props: { sector: 'sucesso', title: 'Sucesso do Cliente', subtitle: 'Gestão de NPS e tempo de atendimento' },
          meta: { embed: true },
        },
        {
          path: 'ti',
          component: SectorDashboard,
          props: { sector: 'ti', title: 'TI', subtitle: 'Gestão de prejuízo evitado, despesas e receita por IA' },
          meta: { embed: true },
        },
        {
          path: 'logistica',
          component: SectorDashboard,
          props: { sector: 'logistica', title: 'Logística', subtitle: 'Gestão de savings e turmas atendidas' },
          meta: { embed: true },
        },
        {
          path: 'academico',
          component: SectorDashboard,
          props: { sector: 'academico', title: 'Acadêmico', subtitle: 'Gestão de inscrições, conversão e prazos' },
          meta: { embed: true },
        },
      ],
    },
  ],
})

function requiredPermissionForPath(path) {
  const permByKey = {
    geral: 100,
    comercial: 102,
    marketing: 104,
    operacoes: 106,
    compras: 108,
    sucesso: 110,
    ti: 112,
    logistica: 114,
    academico: 116,
  }

  const p = String(path || '')
  const clean = p.indexOf('/embed/') === 0 ? p.slice('/embed/'.length) : p.replace(/^\//, '')
  const key = clean.split('/')[0] || ''
  if (key === 'geral' || key === 'geral-comercial') return permByKey.geral
  return permByKey[key]
}

function firstAllowedPath(perms, isEmbed) {
  const items = [
    { key: 'geral-comercial', perm: 100 },
    { key: 'comercial', perm: 102 },
    { key: 'marketing', perm: 104 },
    { key: 'operacoes', perm: 106 },
    { key: 'compras', perm: 108 },
    { key: 'sucesso', perm: 110 },
    { key: 'ti', perm: 112 },
    { key: 'logistica', perm: 114 },
    { key: 'academico', perm: 116 },
  ]

  const found = items.find((it) => perms.indexOf(it.perm) !== -1)
  if (!found) return ''

  if (isEmbed) {
    const embedKey = found.key === 'geral-comercial' ? 'geral' : found.key
    return `/embed/${embedKey}`
  }  return `/${found.key}`
}

router.beforeEach((to, from, next) => {
  // Se veio token na URL, salva e remove da URL (para não vazar/compartilhar acidentalmente).
  const tokenFromQuery = to && to.query && typeof to.query.token === 'string' ? to.query.token : ''
  if (tokenFromQuery) {
    setAuthToken(tokenFromQuery)
    // remove token do query
    // eslint-disable-next-line no-unused-vars
    const { token, ...rest } = to.query
    return next({ path: to.path, query: rest, hash: to.hash, replace: true })
  }

  // Rotas públicas
  if (to && to.name === 'unauthorized') return next()

  // Exige token para qualquer outra rota
  const stored = getAuthToken()
  if (!stored) return next({ name: 'unauthorized', replace: true })

  // Bloqueia acesso se não tiver a permissão da tela
  const perms = getUserPermissions(stored)
  const required = requiredPermissionForPath(to && to.path)
  if (required && perms.indexOf(required) === -1) {
    const isEmbed = String(to && to.path).indexOf('/embed/') === 0
    const fallback = firstAllowedPath(perms, isEmbed)
    if (fallback) return next({ path: fallback, replace: true })
    return next({ name: 'unauthorized', replace: true })
  }

  return next()
})

export default router